export const faqItems = [
  {
    id: 1,
    question: '被窝影院需要注册账号吗？',
    answer: '完全不需要！被窝影院坚持免费电视剧大全理念，所有最新电视剧免费、热播剧完整版均可直接在线观看，无需注册、无需登录，打开即看，追剧零门槛。',
  },
  {
    id: 2,
    question: '在手机上可以流畅观看吗？',
    answer: '当然可以。被窝影院全面适配手机、平板和电脑，国产剧免费观看在移动端同样高清流畅不缓冲，无论你是在通勤路上还是窝在沙发上，都能享受舒适的追剧体验。',
  },
  {
    id: 3,
    question: '视频画质怎么样？有高清吗？',
    answer: '我们提供高清和超清两种画质选择，所有热播剧完整版默认以高清在线播放，画质清晰细腻，让你不错过任何一个精彩镜头。',
  },
  {
    id: 4,
    question: '剧集更新速度跟得上吗？',
    answer: '热门剧集几乎与卫视同步更新！全集在线看最新电视剧免费的承诺我们说到做到，新剧上线后我们会第一时间更新，让你追剧永远快人一步。',
  },
  {
    id: 5,
    question: '播放时有广告打扰吗？',
    answer: '被窝影院采用极简广告策略，绝不在播放中途插播广告打断你的观影体验。我们深知追剧的沉浸感有多重要，所以广告只出现在页面边缘，绝不干扰剧情节奏。',
  },
];

export const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '长安十二时辰',
    category: '古装悬疑',
    heat: '9.8',
    trend: 'up',
    description: '雷佳音、易烊千玺主演，大唐长安城反恐24小时，服化道精良，节奏紧凑扣人心弦。',
  },
  {
    id: 2,
    rank: 2,
    title: '庆余年第二季',
    category: '古装权谋',
    heat: '9.7',
    trend: 'up',
    description: '张若昀、陈道明主演，范闲回归京都，朝堂风云再起，第二季口碑热度双丰收。',
  },
  {
    id: 3,
    rank: 3,
    title: '狂飙',
    category: '刑侦涉案',
    heat: '9.6',
    trend: 'stable',
    description: '张译、张颂文主演，横跨二十年的黑白较量，年度现象级爆款国产剧。',
  },
  {
    id: 4,
    rank: 4,
    title: '三体',
    category: '科幻巨制',
    heat: '9.5',
    trend: 'up',
    description: '刘慈欣原著改编，中国科幻剧里程碑之作，视觉震撼与思想深度兼备。',
  },
  {
    id: 5,
    rank: 5,
    title: '漫长的季节',
    category: '悬疑生活',
    heat: '9.4',
    trend: 'stable',
    description: '范伟、秦昊主演，跨越时空的悬疑故事，东北小城的人间悲欢，口碑封神之作。',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '热播剧场',
    subtitle: '正在热播的国产好剧一网打尽',
    description: '精选当下最火爆的国产电视剧，从古装大剧到都市情感，从悬疑刑侦到科幻巨制，每一部都是口碑与热度兼备的精品之作，让你不错过任何一部好剧。',
    tag: '每日更新',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20scene%20with%20elaborate%20traditional%20clothing%2C%20ancient%20palace%20interior%20with%20warm%20lantern%20light%2C%20dramatic%20composition%2C%20rich%20golden%20and%20red%20tones%2C%20cinematic%20photography%20style%2C%20warm%20atmosphere%2C%20soft%20lighting&width=800&height=500&seq=carousel-1&orientation=landscape',
  },
  {
    id: 2,
    title: '经典重温',
    subtitle: '那些年我们追过的神剧',
    description: '时光流逝但经典永不褪色。我们整理了一系列值得反复回味的经典国产剧，从《琅琊榜》到《甄嬛传》，从《父母爱情》到《武林外传》，每一部都是国产剧的瑰宝。',
    tag: '经典专区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20urban%20Chinese%20drama%20scene%20in%20a%20cozy%20cafe%20setting%2C%20two%20characters%20having%20intimate%20conversation%2C%20warm%20natural%20window%20light%2C%20soft%20bokeh%20background%2C%20contemporary%20lifestyle%2C%20golden%20hour%20atmosphere%2C%20cinematic%20photography&width=800&height=500&seq=carousel-2&orientation=landscape',
  },
  {
    id: 3,
    title: '独家专题',
    subtitle: '被窝精选 · 编辑推荐片单',
    description: '我们的编辑团队每周围绕特定主题精选优质剧集，从"国产悬疑天花板"到"治愈系生活剧"，从"国产科幻崛起"到"那些改编超越原著的剧"，给你不一样的追剧视角。',
    tag: '编辑精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20Chinese%20drama%20scene%20with%20moody%20lighting%2C%20detective%20in%20a%20rain%20soaked%20street%20at%20night%2C%20neon%20reflections%2C%20dramatic%20shadows%2C%20cinematic%20warm%20amber%20and%20deep%20shadow%20color%20contrast%2C%20film%20noir%20style&width=800&height=500&seq=carousel-3&orientation=landscape',
  },
  {
    id: 4,
    title: '新片速递',
    subtitle: '最新上线的热门剧集抢先看',
    description: '第一时间为你呈现各大平台最新上线的电视剧。无论是备受期待的大IP改编，还是黑马逆袭的口碑新作，被窝影院都为你一网打尽，让你追剧永远走在最前沿。',
    tag: '新剧上线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20warm%20living%20room%20scene%2C%20multi%20generational%20family%20gathering%2C%20cozy%20home%20atmosphere%2C%20soft%20natural%20light%20through%20curtains%2C%20warm%20earth%20tones%2C%20heartfelt%20documentary%20style%20photography&width=800&height=500&seq=carousel-4&orientation=landscape',
  },
];

export const appData = {
  id: 1,
  title: '被窝影院 · 移动观影',
  subtitle: '随时随地，窝在被窝里看剧',
  description: '被窝影院全面适配移动端，无需下载APP，浏览器打开即可享受与桌面端一致的高清流畅观影体验。支持投屏到电视，让你的被窝变成私人影院。',
  features: ['无需下载', '高清流畅', '支持投屏', '极速加载', '省流量模式'],
};

export const updatesItems = [
  {
    id: 1,
    date: '2026.07.31',
    title: '《大奉打更人》全40集上线',
    description: '王鹤棣、田曦薇主演古装探案喜剧全集上线，许七安穿越古代破案之旅，笑点与悬念齐飞。',
    tag: '新剧上线',
  },
  {
    id: 2,
    date: '2026.07.28',
    title: '《藏海传》更新至第32集',
    description: '肖战、张婧仪主演古装权谋大剧持续热播中，汪藏海入仕搅动朝堂风云，每周一至周四更新。',
    tag: '热播更新',
  },
  {
    id: 3,
    date: '2026.07.25',
    title: '热播榜单全新改版上线',
    description: '榜单算法升级，新增"口碑指数"和"讨论热度"双维度排序，帮你更快找到值得追的好剧。',
    tag: '站内公告',
  },
  {
    id: 4,
    date: '2026.07.22',
    title: '《国色芳华》全36集一次放送',
    description: '杨紫、李现二搭古装商战剧全集上线，以牡丹为引讲述大唐商业传奇，服饰美学令人惊艳。',
    tag: '全集上线',
  },
  {
    id: 5,
    date: '2026.07.18',
    title: '暑期档剧集专题页面上线',
    description: '汇聚今夏最值得追的热门剧集，《神隐》《藏海传》《国色芳华》等一网打尽，暑假追剧不迷路。',
    tag: '专题上线',
  },
  {
    id: 6,
    date: '2026.07.15',
    title: '播放器体验全面优化升级',
    description: '新增倍速播放、记忆播放进度、画中画模式等多项功能，追剧体验更加丝滑流畅。',
    tag: '功能更新',
  },
  {
    id: 7,
    date: '2026.07.10',
    title: '《神隐》全40集高清完整版上线',
    description: '赵露思、王安宇主演仙侠剧全集上线，上古真神之子历劫重生，浪漫虐恋引爆全网讨论。',
    tag: '全集上线',
  },
];

export const contactData = {
  id: 1,
  title: '联系我们',
  subtitle: '投稿 · 建议 · 合作',
  description: '如果你有好的剧集推荐、原创剧评投稿或商务合作意向，欢迎通过以下方式联系我们。被窝影院期待与每一位热爱追剧的朋友交流。',
  email: 'contact@beiwocinema.com',
};

export const cardsItems = [
  {
    id: 1,
    title: '古装大剧专区',
    description: '从《长安十二时辰》到《庆余年》，从《琅琊榜》到《甄嬛传》，国剧古装巅峰之作全收录。服化道考究、剧情引人入胜，每一部都值得细品。',
    icon: 'ri-sword-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20hero%20standing%20in%20ancient%20palace%20with%20flowing%20robes%2C%20dramatic%20lighting%20from%20lanterns%2C%20rich%20deep%20red%20and%20gold%20color%20palette%2C%20cinematic%20widescreen%20composition%2C%20warm%20atmospheric%20lighting&width=600&height=400&seq=card-1&orientation=landscape',
  },
  {
    id: 2,
    title: '悬疑刑侦剧场',
    description: '《狂飙》《漫长的季节》《白夜追凶》《沉默的真相》，国产悬疑剧天花板一次集齐。烧脑剧情、精湛演技，让你欲罢不能。',
    icon: 'ri-search-eye-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20detective%20office%20interior%20with%20evidence%20board%20and%20case%20files%2C%20warm%20desk%20lamp%20light%20casting%20dramatic%20shadows%2C%20noir%20atmosphere%2C%20rich%20brown%20and%20amber%20tones%2C%20cinematic%20photography&width=600&height=400&seq=card-2&orientation=landscape',
  },
  {
    id: 3,
    title: '都市情感剧场',
    description: '聚焦当代都市生活的情感故事，从甜蜜恋爱到家庭温情，从职场奋斗到人生百态，这里有最贴近你生活的国产好剧。',
    icon: 'ri-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20modern%20apartment%20interior%20with%20soft%20sunset%20light%20through%20large%20windows%2C%20cozy%20sofa%20with%20throw%20blankets%2C%20city%20skyline%20in%20background%2C%20intimate%20home%20atmosphere%2C%20warm%20peach%20and%20gold%20tones%2C%20lifestyle%20photography&width=600&height=400&seq=card-3&orientation=landscape',
  },
  {
    id: 4,
    title: '科幻奇幻专区',
    description: '《三体》领衔国产科幻剧崛起，《神隐》《苍兰诀》开启东方奇幻新篇章。宏大的世界观、震撼的视觉效果，国产想象力不输好莱坞。',
    icon: 'ri-rocket-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20science%20fiction%20scene%20with%20glowing%20holographic%20displays%2C%20deep%20space%20background%20with%20stars%2C%20warm%20golden%20accent%20lights%2C%20atmospheric%20and%20mysterious%2C%20cinematic%20widescreen%20composition&width=600&height=400&seq=card-4&orientation=landscape',
  },
  {
    id: 5,
    title: '喜剧综艺专区',
    description: '轻松一刻，欢乐相伴。《武林外传》《炊事班的故事》等经典情景喜剧，搭配最新热门综艺内容，让你的追剧时光充满笑声。',
    icon: 'ri-emotion-laugh-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20Chinese%20comedy%20scene%20with%20warm%20lighting%2C%20colorful%20decor%2C%20lively%20atmosphere%2C%20group%20of%20people%20laughing%20together%2C%20cozy%20indoor%20setting%2C%20golden%20warm%20tones%2C%20happy%20vibe%20photography&width=600&height=400&seq=card-5&orientation=landscape',
  },
  {
    id: 6,
    title: '年代剧经典',
    description: '《人世间》《山海情》《大江大河》等年代剧巨制，以细腻笔触描绘时代变迁中的普通人命运，厚重、真实、感人至深。',
    icon: 'ri-history-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20period%20drama%20scene%20with%20vintage%20furniture%20and%20warm%20sepia%20tones%2C%20old%20photographs%20on%20wall%2C%20soft%20afternoon%20light%20through%20lace%20curtains%2C%20sentimental%20atmosphere%2C%20documentary%20style%20photography&width=600&height=400&seq=card-6&orientation=landscape',
  },
];

export const commentsItems = [
  {
    id: 1,
    author: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20profile%20avatar%20illustration%20of%20a%20young%20person%2C%20warm%20peach%20background%2C%20simple%20line%20art%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-1&orientation=squarish',
    date: '2026.07.30',
    content: '被窝影院真的太良心了！全集在线看免费电视剧大全，画质高清流畅不缓冲，终于不用到处找资源了。狂飙我刷了三遍，每次看都有新发现。',
    show: '狂飙',
    rating: 5,
  },
  {
    id: 2,
    author: '窝在被窝里追剧',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20profile%20avatar%20illustration%20of%20a%20person%20with%20glasses%2C%20warm%20coral%20background%2C%20simple%20line%20art%20style%2C%20thoughtful%20expression&width=80&height=80&seq=avatar-2&orientation=squarish',
    date: '2026.07.29',
    content: '作为一个国产剧爱好者，被窝影院简直就是我的快乐老家。热播剧完整版更新超快，长安十二时辰的画质比我之前看的平台还好，太惊喜了！',
    show: '长安十二时辰',
    rating: 5,
  },
  {
    id: 3,
    author: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20profile%20avatar%20illustration%20of%20a%20person%20with%20headphones%2C%20warm%20amber%20background%2C%20simple%20line%20art%20style%2C%20relaxed%20expression&width=80&height=80&seq=avatar-3&orientation=squarish',
    date: '2026.07.28',
    content: '三体居然也有！而且是最新电视剧免费的完整版，感动哭了。画质和音效都超出预期，科幻场面震撼力十足，推荐所有科幻迷来看。',
    show: '三体',
    rating: 5,
  },
  {
    id: 4,
    author: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20profile%20avatar%20illustration%20of%20a%20smiling%20person%2C%20warm%20rose%20background%2C%20simple%20line%20art%20style%2C%20cheerful%20expression&width=80&height=80&seq=avatar-4&orientation=squarish',
    date: '2026.07.27',
    content: '漫长的季节拍得太好了，被窝影院的国产剧免费观看资源真的全。每天下班回家最大的幸福就是窝在被窝里打开这个网站追两集。',
    show: '漫长的季节',
    rating: 4,
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '长安十二时辰 · 终极预告',
    description: '大唐长安，盛世危局。雷佳音、易烊千玺联袂演绎年度最燃古装悬疑大剧。',
    duration: '03:25',
    views: '128.6万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20Chinese%20historical%20drama%20scene%20with%20ancient%20city%20at%20night%2C%20lanterns%20and%20fire%2C%20soldiers%20in%20armor%2C%20intense%20atmosphere%2C%20warm%20firelight%20against%20dark%20sky%2C%20cinematic%20widescreen%20composition&width=640&height=360&seq=media-1&orientation=landscape',
  },
  {
    id: 2,
    title: '狂飙 · 高光名场面',
    description: '张颂文"告诉老默我想吃鱼了"名场面回顾，年度演技天花板。',
    duration: '05:18',
    views: '256.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20scene%20in%20a%20dimly%20lit%20room%2C%20two%20men%20in%20tense%20confrontation%2C%20single%20overhead%20light%2C%20dramatic%20shadows%2C%20warm%20amber%20lighting%2C%20cinematic%20photography&width=640&height=360&seq=media-2&orientation=landscape',
  },
  {
    id: 3,
    title: '三体 · 古筝行动震撼还原',
    description: '纳米飞刃切割审判日号！国产科幻剧史上最具想象力的视觉奇观。',
    duration: '04:42',
    views: '189.7万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20scene%20with%20a%20massive%20ship%20on%20dark%20water%2C%20mysterious%20glowing%20energy%20lines%2C%20starry%20night%20sky%2C%20atmospheric%20and%20suspenseful%2C%20warm%20golden%20accents%20against%20deep%20blue%2C%20cinematic&width=640&height=360&seq=media-3&orientation=landscape',
  },
  {
    id: 4,
    title: '庆余年第二季 · 范闲归来',
    description: '张若昀回归！范闲重伤后浴火重生，京都风云再起，权谋升级更精彩。',
    duration: '06:10',
    views: '312.5万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20hero%20standing%20on%20ancient%20city%20wall%20overlooking%20vast%20landscape%2C%20flowing%20robes%20in%20wind%2C%20golden%20sunset%20sky%2C%20epic%20cinematic%20composition%2C%20warm%20dramatic%20lighting&width=640&height=360&seq=media-4&orientation=landscape',
  },
];

export const featuresItems = [
  {
    id: 1,
    icon: 'ri-film-line',
    title: '海量剧库',
    description: '汇聚全网最新电视剧免费资源，从热门新剧到经典老片，免费电视剧大全满足各种追剧需求。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清画质',
    description: '热播剧完整版提供高清在线画质，细节纤毫毕现，搭配流畅不缓冲的播放体验，观影更沉浸。',
  },
  {
    id: 3,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    description: '全集在线看最新电视剧，与卫视同步更新，让你第一时间追到最新集，不再被剧透困扰。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    description: '国产剧免费观看无需注册、不强制下载，纯净观影环境，保护你的隐私和观看记录。',
  },
];

export const aboutData = {
  id: 1,
  title: '关于被窝影院',
  content: '被窝影院是一个致力于为观众提供免费电视剧大全的在线平台。我们相信，好的内容不应该被付费墙阻隔。从热播剧完整版到经典国产剧免费观看，我们精心收录每一部值得被看到的作品，以高清流畅不缓冲的播放体验，让每一位观众都能在最舒适的状态下享受追剧的乐趣。窝在被窝里看剧，是我们能想到的最幸福的事。',
  stats: [
    { label: '收录剧集', value: '5,000+' },
    { label: '日活跃用户', value: '80万+' },
    { label: '高清覆盖率', value: '99%' },
    { label: '日均更新', value: '50+集' },
  ],
};

export const topicsItems = [
  { id: 1, name: '古装剧', heat: '🔥 热议' },
  { id: 2, name: '悬疑剧', heat: '📈 飙升' },
  { id: 3, name: '仙侠剧', heat: '💫 热门' },
  { id: 4, name: '都市情感', heat: '❤️ 追更中' },
  { id: 5, name: '科幻剧', heat: '🚀 新趋势' },
  { id: 6, name: '年代剧', heat: '🏆 口碑' },
  { id: 7, name: '刑侦剧', heat: '🔥 火爆' },
  { id: 8, name: '喜剧', heat: '😄 轻松' },
  { id: 9, name: '权谋剧', heat: '👑 经典' },
  { id: 10, name: '青春剧', heat: '🌸 清新' },
];

export const indexItems = [
  {
    id: 1,
    title: '2026暑期档追剧指南',
    description: '暑假过半，这些高分好剧你都追了吗？',
    icon: 'ri-sun-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20vibes%20with%20bright%20sunlight%20through%20window%2C%20cozy%20living%20room%20with%20TV%20screen%2C%20warm%20golden%20afternoon%20light%2C%20relaxed%20summer%20atmosphere%2C%20lifestyle%20photography&width=400&height=280&seq=index-1&orientation=landscape',
  },
  {
    id: 2,
    title: '国产悬疑剧天花板合集',
    description: '从《白夜追凶》到《漫长的季节》，国产悬疑的巅峰时刻。',
    icon: 'ri-moon-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20night%20scene%20with%20foggy%20alley%20and%20warm%20street%20lamp%20light%2C%20atmospheric%20shadows%2C%20suspenseful%20mood%2C%20cinematic%20noir%20photography%20with%20amber%20tones&width=400&height=280&seq=index-2&orientation=landscape',
  },
  {
    id: 3,
    title: '张若昀古装宇宙全收录',
    description: '从《庆余年》到《雪中悍刀行》，张若昀的古装角色大盘点。',
    icon: 'ri-user-star-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20young%20scholar%20in%20white%20robes%20reading%20under%20ancient%20tree%2C%20soft%20dappled%20sunlight%2C%20tranquil%20garden%20setting%2C%20warm%20natural%20tones%2C%20elegant%20composition&width=400&height=280&seq=index-3&orientation=landscape',
  },
  {
    id: 4,
    title: '那些年我们追过的仙侠',
    description: '从《仙剑奇侠传》到《神隐》，仙侠剧二十年经典回顾。',
    icon: 'ri-cloud-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%20and%20misty%20clouds%2C%20warm%20golden%20sunrise%20light%2C%20dreamy%20atmosphere%2C%20traditional%20ink%20painting%20aesthetic%20with%20soft%20colors&width=400&height=280&seq=index-4&orientation=landscape',
  },
  {
    id: 5,
    title: '豆瓣9分以上国产剧',
    description: '口碑炸裂！这些国产神剧每一部都值得N刷。',
    icon: 'ri-star-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20living%20room%20with%20bookshelf%20and%20warm%20reading%20lamp%2C%20cozy%20intellectual%20atmosphere%2C%20soft%20golden%20light%2C%20sophisticated%20interior%20design%2C%20warm%20wood%20tones&width=400&height=280&seq=index-5&orientation=landscape',
  },
  {
    id: 6,
    title: '高分原著改编剧盘点',
    description: '这些改编自小说的国产剧，有的超越原著，有的忠实还原。',
    icon: 'ri-book-open-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20stack%20of%20books%20and%20warm%20candlelight%2C%20soft%20blanket%2C%20intimate%20atmosphere%2C%20golden%20amber%20lighting%2C%20literary%20aesthetic%20photography&width=400&height=280&seq=index-6&orientation=landscape',
  },
  {
    id: 7,
    title: '新晋影帝影后电视剧作品',
    description: '盘点近年来从电视剧走向大银幕的实力派演员。',
    icon: 'ri-award-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20with%20warm%20spotlight%20and%20velvet%20curtains%2C%20theater%20atmosphere%2C%20golden%20and%20deep%20red%20tones%2C%20prestigious%20award%20ceremony%20aesthetic&width=400&height=280&seq=index-7&orientation=landscape',
  },
  {
    id: 8,
    title: '一人分饰多角神演技',
    description: '从潘粤明到张一山，那些让人惊艳的多重角色演绎。',
    icon: 'ri-emotion-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20theater%20mask%20with%20split%20lighting%2C%20half%20warm%20golden%20half%20deep%20shadow%2C%20artistic%20portrait%20style%2C%20emotional%20contrast%2C%20cinematic%20photography&width=400&height=280&seq=index-8&orientation=landscape',
  },
  {
    id: 9,
    title: '被窝编辑的私藏片单',
    description: '编辑团队内部票选出的最爱剧集，每一部都是心头好。',
    icon: 'ri-heart-add-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20bedroom%20at%20night%20with%20string%20lights%20and%20laptop%20on%20bed%2C%20warm%20blanket%2C%20intimate%20home%20atmosphere%2C%20soft%20golden%20glow%2C%20comfortable%20lifestyle%20photography&width=400&height=280&seq=index-9&orientation=landscape',
  },
];